import styles from './ResizeHandles.module.css';

type ResizeEdge =
  | 'top'
  | 'bottom'
  | 'left'
  | 'right'
  | 'top-left'
  | 'top-right'
  | 'bottom-left'
  | 'bottom-right';

const EDGES: ResizeEdge[] = [
  'top',
  'bottom',
  'left',
  'right',
  'top-left',
  'top-right',
  'bottom-left',
  'bottom-right',
];

interface ResizeHandlesProps {
  onResizeStart: (edge: ResizeEdge) => (e: React.PointerEvent) => void;
}

export function ResizeHandles({ onResizeStart }: ResizeHandlesProps) {
  return (
    <>
      {EDGES.map(edge => (
        <div
          key={edge}
          className={styles.resizeHandle}
          data-edge={edge}
          onPointerDown={onResizeStart(edge)}
        />
      ))}
    </>
  );
}
